import { useMemo } from "react"

if (!("gtag" in window)) {
  ;(window as Window)["gtag"] = () => undefined
}
const track = (action: string, values: object) => {
  window.gtag("event", action, values)
}

export const captureException = (message: string) => {
  track("exception", { description: message, fatal: true })
}

export const captureError = (message: string) => {
  track("exception", { description: message, fatal: false })
}

export const useGoogleAnalytics = () => {
  const purchase = (values: object) => track("purchase", values)
  const pageView = (path: string, values: object) =>
    track("page_view", {
      page_path: path,
      page_title: window.document.title,
      ...values,
    })

  return useMemo(
    () => ({
      track,
      purchase,
      pageView,
    }),
    []
  )
}
